export default {
  data() {
    return {
      fields: [
        {
          dataClass: 'text-center',
          name: '__slot:icon',
        },
        {
          name: '__slot:company_name',
          title: 'Company name',
          sortField: 'company_overviews.company_name',
        },
        {
          name: 'registration_number',
          title: 'Registration number',
          sortField: 'company_overviews.registration_number',
        },
        {
          name: '__slot:created_at',
          title: 'Created',
          sortField: 'created_at',
        },
        {
          name: '__slot:options',
        },
      ],
    };
  },
  methods: {
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    editRow() {},
    deleteRow() {},
    onLoading() {},
    onLoaded() {},
  },
};
